import React from 'react'

import Colors from 'utils/Colors'
import LaunchIcon from '@mui/icons-material/Launch'

export default function HelpDialog() {
  return (
    <div
      style={{
        fontSize: '1.6rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <div>
        <h2>Sistema KYE</h2>
        Bem-vindo(a) ao sistema de Know Your Employee (KYE), que permite fazer análise de antecedentes (Background
        Check) dos candidatos à vagas de colaborador na XP.
        <br></br>O sistema está interligado com a base de dados da <b>Greenhouse</b> e é de lá que o CPF do candidato, a
        área de atuação, o cargo pretendido e o estágio atual da contratação são obtidos.
        <br></br>
        <br></br>
        <h3>Como funciona o fluxo</h3>
        <h4>Etapa 1: candidato adicionado à Greenhouse</h4>
        Quando um candidato é adicionado à Greenhouse, ele aparecerá também no KYE, mas ele só terá seus antecedentes
        analisados quando for movido para o estágio de <b>&quot;Background Check&quot;</b> na Greenhouse.<br></br>
        <br></br>
        <h4>Etapa 2: Background Check</h4>
        Quando um candidato é movido para o estágio denominado <b>&quot;Background Check&quot;</b> na Greenhouse, o
        sistema KYE começará o processamento, e analisará:
        <ul>
          <li>Dados pessoais</li>
          <li>Participações Societárias</li>
          <li>Exposição Política</li>
          <li>Processos Judiciais</li>
          <li>Presença em Mídias Negativas</li>
          <li>Presença em Listas Restritivas</li>
          <li>Presença em Listas de Compliance da XP</li>
          <li>Vínculo com Outros Colaboradores da XP</li>
        </ul>
        <h4>Etapa 3: Resultado do Background Check e revisão manual</h4>
        <p>
          O processamento do Background Check pode levar de alguns minutos a algumas horas.
          <br></br>
          No final do processamento, um relatório será gerado com um <b>score de risco</b> do candidato.
        </p>
        <br></br>
        <p>
          Além disso, para cada apontamento encontrado no Background Check, uma <b>revisão manual</b> será solicitada
          para que <b>analistas</b>, ou seja, usuários do KYE, decidam quanto ao avanço ou não do candidato no processo
          de contratação.
        </p>
        <br></br>
        <p>
          Se os revisores decidirem por <b style={{ color: Colors.reprovedRed }}>reprovar</b> o candidato, então o fluxo
          de contratação se encerra aqui.
        </p>
        <br></br>
        <p>
          Se não houver apontamentos ou se os revisores decidirem por{' '}
          <b style={{ color: Colors.approvedGreen }}>aprovar</b> o candidato, ele então será{' '}
          <b>movido para o próximo estágio da Greenhouse</b>.
        </p>
        <br></br>
        <h4>Etapa 4: Aguardando Movimentação na Greenhouse</h4>
        <p>
          Ao ser aprovado no Background Check, o candidato será movido automaticamente para o próximo estágio da
          Greenhouse.
          <br></br>
          <br></br>
          Como na Greenhouse pode haver outras etapas, no lado do KYE, a aplicação do candidato ficará em stand-by até
          que os administradores da Greenhouse movam o candidato para o estágio de <b>&quot;Análise de Crédito&quot;</b>
          .
        </p>
        <br></br>
        <h4>Etapa 5: Análise de Crédito</h4>
        Quando um candidato antinge o estágio denominado <b>&quot;Análise de Crédito&quot;</b> na Greenhouse, o sistema
        KYE começará outro processamento, e analisará:
        <ul>
          <li>Score de Crédito</li>
          <li>Pendências Financeiras no Serasa e outras instituições</li>
        </ul>
        <h4>Etapa 6: Resultado da Análise de Crédito e revisão manual</h4>
        <p>
          O processamento do Análise de Crédito pode levar alguns minutos.
          <br></br>
          No final do processamento um relatório será gerado com as pendências do candidato.
        </p>
        <br></br>
        <p>
          Uma <b>revisão manual</b> poderá ser solicitada também nesta etapa, a depender da saúde financeira do
          candidato. As regras de aprovação são iguais às do Background Check.
        </p>
        <br></br>
        <h4>Fim do Fluxo no KYE</h4>
        <p>Se aprovado na análise de crédito, o candidato será movido para o próximo estágio da Greenhouse.</p>
        <br></br>
        <p>
          No lado do KYE, ele será considerado com o status <b style={{ color: Colors.approvedGreen }}>Aprovado</b> e
          não haverá procedimentos adicionais, embora ainda possa ser reprovado na Greenhouse.
        </p>
        <br></br>
        <hr></hr>
        <br></br>
        <h2>Terminologias</h2>
        <br></br>
        <h3>Candidato</h3>
        <p>
          Representa uma pessoa que está se aplicando a uma vaga na XP. Ou melhor, o perfil dessa pessoa na Greenhouse.
        </p>
        <br></br>
        <h3>Aplicação</h3>
        <p>
          Representa a candidatura de uma pessoa na Greenhouse.
          <br></br>
          Na tela principal você encontra a lista de aplicações feitas pelos candidatos.
          <br></br>
          Cada aplicação tem um cargo e uma área de atuação, informações essas que vieram da Greenhouse.
          <br></br>
          Você consegue ver todos os detalhes de uma aplicação e dados obtidos pelo processamento do KYE, ao clicar no
          botão{' '}
          <LaunchIcon
            style={{
              color: Colors.primaryColor,
              fontSize: 18,
            }}
          />
          no canto direito da lista.
        </p>
        <br></br>
        <h3>Estágio da Greenhouse</h3>
        <p>
          É a etapa em que uma aplicação está no fluxo de contratação da Greenhouse. Somente os administradores da
          Greenhouse podem mover as aplicações para outros estágios.
          <br></br>O estágio da Greenhouse é importante no KYE, pois os processamentos de antecedentes são feitos
          somente quando a aplicação está no estágio correto (Background Check ou Análise de Crédito).
        </p>
        <br></br>
        <h3>Andamento da Aplicação do Candidato</h3>
        <p>
          O andamento da aplicação está relacionado a que parte do processamento do KYE a aplicação se encontra.
          <br></br>
          Ao passar o mouse sobre uma aplicação na lista da tela inicial você poderá ver uma pequena linha do tempo
          verde, que representa o andamento, com as seguintes etapas:
          <br></br>
          <ol>
            <li>
              <b>Aplicação Iniciada</b>: a aplicação entrou no sistema do KYE
            </li>
            <li>
              <b>Processando BGC</b>: a aplicação foi movida para o Background Check (BGC) e o processamento começou
            </li>
            <li>
              <b>Análise de Crédito Pendente</b>: Background Check (BGC) terminou e agora aguarda-se que a aplicação
              seja movida para a etapa de Análise de Crédito na Greenhouse
            </li>
            <li>
              <b>Processando Análise de Crédito</b>: a aplicação foi movida para a Análise de Crédito e o processamento
              começou
            </li>
            <li>
              <b>Concluído</b>: a Análise de Crédito terminou.
            </li>
          </ol>
        </p>
        <br></br>
        <h3>Status da Aplicação do Candidato</h3>
        <p>O status da aplicação está relacionado resultado do processamento do KYE.</p>
        <br></br>
        <h3>Tipos de Status da Aplicação do Candidato</h3>
        <p>
          <ul
            style={{
              listStyleType: 'none',
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
            }}
          >
            <li>
              <h4>Pendente:</h4> <p>O fluxo de contratação está em andamento no KYE e/ou na Greenhouse.</p>
            </li>
            <li>
              <h4 style={{ color: Colors.approvedGreen }}>Aprovado(a):</h4>
              <p>
                O candidato foi aprovado em todas as etapas do KYE (Background Check e Análise de Crédito) ou foi
                marcado como Hired na Greenhouse.
              </p>
            </li>
            <li>
              <h4 style={{ color: Colors.reprovedRed }}>Reprovado(a):</h4>
              <p>
                O candidato foi reprovado em alguma etapa do KYE (Background Check ou Análise de Crédito) ou foi marcado
                como Rejected na Greenhouse.
              </p>
            </li>
          </ul>
        </p>
      </div>
      <br></br>
      <p>
        <h3>Revisão Manual</h3>Se o Background Check ou Análise de Crédito encontrar pendências, os analistas da XP
        (usuários do sistema KYE) terão que revisar o caso, e decidir se a aplicação continua ou não no fluxo.
      </p>
      <br></br>
      <div>
        <h3>Tipos de Status da Revisão Manual</h3>
        <ul
          style={{
            listStyleType: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          <li>
            <h4>Pendente:</h4> <p>A revisão ainda não foi feita pela área.</p>
          </li>
          <li>
            <h4 style={{ color: Colors.approvedGreen }}>Aprovado:</h4>
            <p>Um membro da área marcou que no tema analisado, o candidato está aprovado.</p>
            <p>
              <strong>Importante: </strong>O candidato precisa ser aprovado em todas as revisões de Background Check e
              Análise de Crédito para ser aprovado no fluxo inteiro.
            </p>
          </li>
          <li>
            <h4 style={{ color: Colors.reprovedRed }}>Reprovado: </h4>
            <p>Um membro da área marcou que no tema analisado, o candidato está reprovado.</p>

            <p>
              <strong>Importante: </strong> Se o candidato for reprovado em qualquer revisão, será reprovado no fluxo de
              contratação inteiro e será rejeitado na Greenhouse.
            </p>
          </li>
          <li>
            <h4 style={{ color: Colors.orange }}>Suspenso:</h4>
            <p>
              Outra revisão foi marcada como <strong>Reprovada</strong> e o fluxo de contratação do candidato foi
              interrompido.
            </p>

            <p>Ou</p>

            <p>
              O candidato foi marcado como <strong>Hired</strong> ou <strong>Rejected</strong> na Greenhouse sem que o
              fluxo do KYE tenha terminado. Dessa forma, as revisões pendentes se tornam suspensas e as equipes não
              poderão aprovar/reprovar.
            </p>

            <p>
              Para que uma revisão volte para o estado de <strong>Pendente</strong>, é preciso voltar a aplicação para o
              status <strong>Active</strong> na Greenhouse.
            </p>
          </li>
        </ul>
      </div>
      <br></br>
      <hr></hr>
      <br></br>
      <h2>Perguntas Frequentes</h2>
      <h3>Greenhouse, Background Check e Análise de Crédito</h3>
      <ol>
        <li>
          <h4>O cargo e/ou área da aplicação estão incorretos.</h4>
          <p>
            Corrija os dados na Greenhouse e aperte o botão <b>Sincronizar</b> no painel de detalhes da aplicação
            (clique no botão{' '}
            <LaunchIcon
              style={{
                color: Colors.primaryColor,
                fontSize: 18,
              }}
            />
            {', '}à direita na lista de aplicações para abrir a visão detalhada).
            <br></br>
            Essas informações são sincronizadas também quando muda-se o estágio na Greenhouse.
          </p>
        </li>
        <li>
          <h4>A aplicação foi movida para o Background Check, mas o processamento não começou. E agora?</h4>
          <p>
            Se o processamento não começou certifique-se de que algum erro não aconteceu.
            <br></br>
            Verifique os <b>custom fields</b> da aplicação na Greenhouse, eles poderão indicar a causa.
            <br></br>
            Uma causa muito comum é preencher o CPF do candidato de forma incorreta na Greenhouse.
            <br></br>
            Corrija os dados na Greenhouse e sincronize no KYE (Pergunta 1).
          </p>
        </li>
        <li>
          <h4>A aplicação foi movida para a Análise de Crédito, mas o processamento não começou. E agora?</h4>
          <p>
            Verifique os <b>custom fields</b> da aplicação na Greenhouse, eles poderão indicar a causa.
            <br></br>
            Uma causa muito comum é que o candidato não foi aprovado no Background Check e tentaram pular estágios na
            Greenhouse.
            <br></br>
            Corrija os dados na Greenhouse e sincronize no KYE (Pergunta 1).
          </p>
        </li>
        <li>
          <h4>O Background Check/Análise de Crédito está demorando demais para processar!</h4>
          <p>
            O processamento geralmente leva alguns minutos, porém em algumas ocasições pode haver instabilidade nos
            sistemas que puxam informações de antecedentes, principalmente as de Processos Judiciais.
            <br></br>
            Nosso time está sempre atuando para manter o sistema eficiente, mas caso uma aplicação demore mais que 72
            horas para processar, entre em contato com nosso suporte e poderemos ajudar.
          </p>
        </li>
      </ol>
      <br></br>
      <h3>Revisões Manuais</h3>
      <ol>
        <li>
          <h4>O que acontece se eu aprovar uma revisão?</h4>
          <p>O fluxo de contratação irá prosseguir somente quando todas as revisões forem aprovadas.</p>
        </li>
        <li>
          <h4>O que acontece se eu reprovar uma revisão?</h4>
          <p>
            O fluxo de contratação será interrompido, o candidato será marcado como reprovado no KYE e rejeitado
            (Rejected) na Greenhouse.
          </p>
          <p>
            Todas as outras revisões serão marcadas como suspensas, já que o pré-requisito para o candidato ser aprovado
            é passar em todas as revisões.{' '}
          </p>
        </li>
        <li>
          <h4>Já aprovei todas as revisões, por que o candidato não foi aprovado?</h4>
          <ul>
            <li>Certifique-se de o candidato foi aprovado em todas as revisões em todas as áreas.</li>
            <li>
              Uma vez que o candidato for aprovado nas revisões de Background Check, o fluxo de contratação da
              Greenhouse irá prosseguir
            </li>
            <li>
              Apenas quando o candidato atingir o estágio de Análise de Crédito na Greenhouse ele será resubmetido outra
              vez ao KYE.
            </li>
            <li>
              Se o candidato for aprovado em todas as etapas da Análise de Crédito, aí sim estará aprovado no fluxo
              inteiro.
            </li>
          </ul>
        </li>
        <li>
          <h4>Depois de aprovar/reprovar, eu posso alterar minha decisão?</h4>
          <p>
            Não. Por uma questão de segurança no fluxo de contratação, todas as decisões de aprovar/reprovar são finais.
            <br />
            Apenas clique em aprovar/reprovar depois de ter analisado e debatido o caso em questão.
          </p>
        </li>
        <li>
          <h4>O RH analisou um caso que não chegou para o Compliance (vice-versa). Quando ele chegará?</h4>
          <p>Todas as revisões são enviadas ao mesmo tempo para as áreas.</p>
          <p>
            Porém, segundo as regras do KYE, algumas revisões são de alçada do RH, outras do Compliance e outras são de
            interesse de ambas as partes.
          </p>
          <p>
            Não se preocupe se sobre um tema não foi derivada nenhuma revisão para a sua área, isso significa que não há
            nenhuma ação a ser tomada por vocês.
          </p>
        </li>
      </ol>
      <div></div>
      Esse texto foi escrito por um humano. Avise-nos caso encontre algum erro grosseiro :)
    </div>
  )
}
